import { ApiError } from "@softmax/observatory-client/transport";

export type ReadResult<T> =
  | { kind: "ready"; data: T }
  | { kind: "unavailable"; status: number; message: string };

export function unwrapReadResult<T>(result: ReadResult<T>): T {
  if (result.kind === "unavailable")
    throw new ApiError(result.message, result.status);

  return result.data;
}
